import { createStore, initStore } from "common-frontend/src/store/Store";
import reduxStorage from "redux-persist/lib/storage";

initStore(createStore(reduxStorage));
